import { atom, selector } from 'recoil';
import { themes } from '../themes';
import { getThemeFromStorage, isSystemDark } from '../utils';
import { ThemeState } from './types';

export const themeState = atom<ThemeState>({
  key: 'theme',
  default: { selected: getThemeFromStorage() || 'system' },
});

export const selectedTheme = selector({
  key: 'selectedTheme',
  get: ({ get }) => {
    const theme = get(themeState);
    if (theme.selected === 'system') {
      return isSystemDark ? themes.dark : themes.light;
    }
    return themes[theme.selected];
  },
});
